/* eslint-disable react/prop-types */
import React, {useEffect, useState} from 'react';
import {Button, Form, Table} from 'react-bootstrap';

const DlmsCosemTable = (props) => (
  <Table>
    <tbody>
    <tr>
      <th className="text-start"><span>Name</span></th>
      <td className="text-end"><span>{props.device.name}</span></td>
    </tr>
    <tr>
      <th className="text-start"><span>Serial Port</span></th>
      <td className="text-end"><span>{props.device.serialPort}</span></td>
    </tr>
    <tr>
      <th className="text-start"><span>Meter Address</span></th>
      <td className="text-end"><span>{props.device.meterAddress}</span></td>
    </tr>
    <tr>
      <th className="text-start"><span>Extended Data</span></th>
      <td className="text-end"><span>{props.device.extendedData ? 'Yes' : 'No'}</span></td>
    </tr>
    </tbody>
  </Table>
);

const DlmsCosemForm = ({device, setDevice, setSaveDisabled}) => {
  const [showEncryptionKey, setShowEncryptionKey] = useState(false);
  const [showAuthenticationKey, setShowAuthenticationKey] = useState(false);

  // verify all required fields are filled before saving
  useEffect(() => {
    const meterAddressOk = device.meterAddress || device.meterAddress === 0;
    if (device.name && device.serialPort && device.baudRate && meterAddressOk
      && device.encryptionKey && device.authenticationKey) {
      setSaveDisabled(false);
    } else {
      setSaveDisabled(true);
    }
  }, [device, setSaveDisabled]);

  const handleChange = (e) => {
    const {name, value, type, checked} = e.target;
    let parsedValue = value;
    if (type === 'checkbox') {
      parsedValue = checked;
    } else if (type === 'number') {
      parsedValue = Number(value);
    }
    setDevice((prev) => ({...prev, [name]: parsedValue}));
  };

  return (
    <Form>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control
          type="text"
          name="name"
          value={device.name}
          onChange={handleChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>Serial Port</Form.Label>
        <Form.Control
          type="text"
          name="serialPort"
          value={device.serialPort}
          onChange={handleChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>Baud Rate</Form.Label>
        <Form.Control
          type="number"
          name="baudRate"
          value={device.baudRate}
          onChange={handleChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>Meter Address</Form.Label>
        <Form.Control
          type="number"
          name="meterAddress"
          value={device.meterAddress}
          onChange={handleChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>Encryption Key</Form.Label>
        <div className="d-flex">
          <Form.Control
            type={showEncryptionKey ? 'text' : 'password'}
            name="encryptionKey"
            value={device.encryptionKey}
            onChange={handleChange}
            className="me-2"/>
          <Button onClick={() => setShowEncryptionKey(!showEncryptionKey)} variant="outline-secondary">
            {showEncryptionKey ? 'Verbergen' : 'Zeigen'}
          </Button>
        </div>
      </Form.Group>
      <Form.Group>
        <Form.Label>Authentication Key</Form.Label>
        <div className="d-flex">
          <Form.Control
            type={showAuthenticationKey ? 'text' : 'password'}
            name="authenticationKey"
            value={device.authenticationKey}
            onChange={handleChange}
            className="me-2"/>
          <Button onClick={() => setShowAuthenticationKey(!showAuthenticationKey)} variant="outline-secondary">
            {showAuthenticationKey ? 'Verbergen' : 'Zeigen'}
          </Button>
        </div>
      </Form.Group>
      <Form.Group className="mt-2">
        <Form.Check
          type="switch"
          id="dlmsCosem-extendedData"
          name="extendedData"
          label="Extended Data (read currents & voltages)"
          checked={!!device.extendedData}
          onChange={handleChange}/>
      </Form.Group>
    </Form>
  );
};

export {DlmsCosemTable, DlmsCosemForm};
